import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yewumingxi",
  "use": "icon-yewumingxi-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-yewumingxi\"><path d=\"M15.056 16H.944c-.217-.077-.43-.157-.6-.323-.178-.175-.267-.394-.344-.621V.944c.077-.217.157-.43.323-.6C.498.166.717.077.944 0h14.112c.217.077.43.157.6.323.178.175.267.394.344.621v14.112c-.077.227-.166.446-.343.62-.171.167-.385.247-.601.324zM14.85 1.154H1.154v13.694h13.694V1.154h.002zm-2.264 2.26V4.48H5.76V3.414h6.826m0 2.346v1.066H5.76V5.76h6.826m0 3.414v1.066H5.76V9.174h6.826M5.76 12.586V11.52h6.826v1.066H5.76M4.48 4.48H3.414V3.414H4.48V4.48m0 7.04v1.066H3.414V11.52H4.48m0-5.76v1.066H3.414V5.76H4.48m0 4.48H3.414V9.174H4.48v1.066\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/yewumingxi.svg
// module id = 531
// module chunks = 4